// src/utils/Onboarding/artifacts.js

const STORAGE_KEY = 'mm_onboarding_artifacts_v1';

function readRoot() {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeRoot(root) {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(root || {}));
  } catch {
    // ignore quota errors silently
  }
}

export function loadArtifacts(sessionId) {
  if (!sessionId) return null;
  const root = readRoot();
  return root[sessionId] || null;
}

export function saveArtifacts(sessionId, patch) {
  if (!sessionId || !patch || typeof patch !== 'object') return;
  const root = readRoot();
  const current = root[sessionId] || {};
  root[sessionId] = { ...current, ...patch };
  writeRoot(root);
}

export function clearArtifacts(sessionId) {
  if (!sessionId) return;
  const root = readRoot();
  if (root[sessionId]) {
    delete root[sessionId];
    writeRoot(root);
  }
}

// Convenience for the image upload feature namespace
export function setImageUploadArtifact(sessionId, data) {
  if (!sessionId) return;
  const current = loadArtifacts(sessionId) || {};
  const next = { ...current, imageUpload: { ...(current.imageUpload || {}), ...(data || {}) } };
  saveArtifacts(sessionId, next);
}

export function getImageUploadArtifact(sessionId) {
  const art = loadArtifacts(sessionId);
  return art && art.imageUpload ? art.imageUpload : null;
}

export function clearImageUploadArtifact(sessionId) {
  if (!sessionId) return;
  const root = readRoot();
  if (!root[sessionId]) return;
  const clone = { ...root[sessionId] };
  delete clone.imageUpload;
  root[sessionId] = clone;
  writeRoot(root);
}

export function setImageUploadSuppress(sessionId, suppress) {
  if (!sessionId) return;
  const current = loadArtifacts(sessionId) || {};
  const next = { ...current, imageUpload: { ...(current.imageUpload || {}), suppress: !!suppress } };
  saveArtifacts(sessionId, next);
}

export function getImageUploadSuppress(sessionId) {
  const iu = getImageUploadArtifact(sessionId);
  return !!(iu && iu.suppress);
}

// Analysis artifacts namespace
export function setAnalysisArtifact(sessionId, data) {
  if (!sessionId) return;
  const current = loadArtifacts(sessionId) || {};
  const next = { ...current, analysis: { ...(current.analysis || {}), ...(data || {}) } };
  saveArtifacts(sessionId, next);
}

export function getAnalysisArtifact(sessionId) {
  const art = loadArtifacts(sessionId);
  return art && art.analysis ? art.analysis : null;
}

export function clearAnalysisArtifact(sessionId) {
  if (!sessionId) return;
  const root = readRoot();
  if (!root[sessionId]) return;
  const clone = { ...root[sessionId] };
  delete clone.analysis;
  root[sessionId] = clone;
  writeRoot(root);
}
